import React from 'react';

function ComposingPromptsContent() {
  return (
    <>
      <p>The core workflow in RepoPrompt involves composing prompts that combine your instructions with selected file context, then sending them to an AI for processing.</p>
      
      <h3>The Compose Tab Workflow</h3>
      <ol>
        <li>Select relevant files from the file tree panel (they'll appear in the "Selected Files" panel)</li>
        <li>Activate any stored prompts you want to use via the prompt tabs</li>
        <li>Click on the "Instructions" tab if not already selected</li>
        <li>Type your specific instructions or query in the main text area</li>
        <li>Review the selected files and approximate token count at the bottom</li>
      </ol>
      
      <h3>Copying for External Use</h3>
      <p>To use your prompt with an external AI service (like ChatGPT web interface):</p>
      <ol>
        <li>After composing your prompt as described above, click the "Copy" button at the bottom left</li>
        <li>The fully formatted prompt (including instructions, file map, file contents, and system messages) is copied to your clipboard</li>
        <li>Paste this complete prompt into your preferred external LLM chat interface</li>
      </ol>
      
      <h3>Understanding the Generated Prompt</h3>
      <p>The prompt RepoPrompt generates typically includes:</p>
      <ul>
        <li><strong>System instructions:</strong> From your active stored prompts</li>
        <li><strong>Your specific query:</strong> From the Instructions text area</li>
        <li><strong>File map:</strong> A structured outline of the selected files</li>
        <li><strong>File contents:</strong> The actual code from selected files</li>
        <li><strong>Code Maps:</strong> If enabled, structured summaries of code definitions</li>
      </ul>
      
      <div className="tip-box">
        <strong>Tip:</strong> For best results, be specific in your instructions about what you want the AI to do with the provided code. Mention file names explicitly when referring to them in your instructions.
      </div>
    </>
  );
}

export default ComposingPromptsContent;